import { ChatListItemLoading } from '../Chat/ChatListItem/ChatListItemLoading.js'

export const LoadingNewChatsIndicator = () => (
  <>
    {[...Array(4)].map((_e, i) => (
      /* eslint-disable-next-line react/no-array-index-key  */
      <ChatListItemLoading key={i} />
    ))}
  </>
)
